import { initAddy } from './addy';
import { GreensMap } from './leaflet';
// Start app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    try {
        const greensMap = new GreensMap();
        initAddy(greensMap);
    }
    catch (err) {
        console.error('Initialization error:', err);
    }
});
